import { GET_USERS } from "../actions/UsersTypes";
const initialState = {
  data: [],
  page: 1,
  total: 0,
  totalPages: 0,
  stats: {},
  isLoading: true,
};
const initial = false;
function UsersReducer(state = initialState, actions) {
  if (actions.type === GET_USERS) {
    return {
      ...state,
      ...actions.payload,
      stats: actions.payload.stats ?? {},
    };
  }
  if (
    actions.type === "LOADING" &&
    actions.payload.action_model === GET_USERS
  ) {
    return {
      ...state,
      isLoading: actions.payload.loading,
    };
  }
  return state;
}

export { UsersReducer };
